import React from 'react'
import { motion } from 'framer-motion'
import { FaGithub, FaLinkedin, FaInstagram, FaTwitter, FaEnvelope } from 'react-icons/fa'
import { staggerItem } from '../animations/variants'

const socials = [
  { name: 'Email', icon: FaEnvelope, url: 'mailto:dalvirohan369@gmail.com' },
  { name: 'LinkedIn', icon: FaLinkedin, url: 'https://linkedin.com/in/rohan-dalvi-552006377' },
  { name: 'Instagram', icon: FaInstagram, url: 'https://instagram.com/rohan_sys_' },
  { name: 'Twitter', icon: FaTwitter, url: 'https://twitter.com/dalvirohan369' },
  { name: 'GitHub', icon: FaGithub, url: 'https://github.com/rohandalvi369' },
]

export default function Footer() {
  return (
    <footer
      style={{
        background: 'transparent',
        borderTop: '1px solid rgba(255,255,255,0.04)',
        padding: '2rem 1rem',
      }}
    >
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <motion.div
          initial="hidden"
          animate="visible"
          style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', marginBottom: '1.5rem' }}
        >
          {socials.map((social, index) => {
            const Icon = social.icon
            return (
              <motion.a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
                variants={staggerItem}
                whileHover={{
                  scale: 1.1,
                  color: '#00d9ff',
                  textShadow: '0 0 15px #00d9ff, 0 0 30px #00d9ff',
                }}
                whileTap={{ scale: 0.95 }}
                style={{ color: 'rgba(255,255,255,0.2)', transition: 'color 0.15s ease' }}
              >
                <Icon size={20} />
              </motion.a>
            )
          })}
        </motion.div>

        <div style={{ textAlign: 'center', fontFamily: 'monospace', fontSize: '0.65rem', letterSpacing: '0.2em', color: 'rgba(255,255,255,0.15)' }}>
          <p>&copy; {new Date().getFullYear()} Rohan Dalvi. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}